import { api } from "#app/http/api";
import { ApiError } from "#shared/infra/apiError";

export const updateCompanyModel = async ({
  companySettingsId,
  modelId,
}: {
  companySettingsId: string;
  modelId: string;
}) => {
  const response = await api.companySettings.updateModel.mutation({
    params: {
      id: companySettingsId,
    },
    body: { modelId },
  });

  if (response.status === 200) {
    return response.body;
  }

  throw new ApiError("Failed to update CompanyModel", response.status, response.body);
};
